var render, staticRenderFns
import script from "./appNavigator.vue?vue&type=script&lang=js"
export * from "./appNavigator.vue?vue&type=script&lang=js"
import style0 from "./appNavigator.vue?vue&type=style&index=0&id=247765de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "247765de",
  null
  
)

export default component.exports